/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MemberUserInput } from '../../models/member-user-input';
import { Response } from '../../models/response';

export interface ApiKeycloakCreateMemberUserPost$Plain$Params {
  Authorization?: string;
      body?: MemberUserInput
}

export function apiKeycloakCreateMemberUserPost$Plain(http: HttpClient, rootUrl: string, params?: ApiKeycloakCreateMemberUserPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Response>> {
  const rb = new RequestBuilder(rootUrl, apiKeycloakCreateMemberUserPost$Plain.PATH, 'post');
  if (params) {
    rb.header('Authorization', params.Authorization, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Response>;
    })
  );
}

apiKeycloakCreateMemberUserPost$Plain.PATH = '/api/keycloak/CreateMemberUser';
